module.exports = __webpack_public_path__ + "img/ZEIT.cdf551db.svg";